module.exports = __webpack_public_path__ + "assets/img/block-hover-beddcd5e.png";